import { createAction, props } from '@ngrx/store';

import { Protocol } from '../models/protocol.model';

export const setProtocols = createAction('[Protocols] Set Protocols', props<{ protocols: Protocol[]; continuationToken: string | null }>());

export const appendProtocols = createAction('[Protocols] Append Protocols', props<{ protocols: Protocol[]; continuationToken: string | null }>());

export const updateProtocol = createAction('[Protocols] Update Protocol', props<{ protocol: Protocol }>());

export const removeProtocol = createAction('[Protocols] Remove Protocol', props<{ id: string }>());

export const setProtocolsLoading = createAction('[Protocols] Set Loading', props<{ loading: boolean }>());
